import { WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR } from "@/constants";
import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import { FreeProductSliderWidgetDefinition } from "@apps/rewards/constants/definitions";
import type { RewardsWidgetInjectorConfig } from "@apps/rewards/types";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import { parseOptionalBooleanDataAttr } from "@ui-utils/Injector/utils";

class FreeProductSliderWidgetInjector {
    constructor(private readonly config: RewardsWidgetInjectorConfig) {}

    start(): void {
        this.config.logger.debug("FreeProductSliderWidgetInjector start", {
            placeholderSelector: this.config.placeholderSelector,
        });

        const widgetName =
            REWARDS_WIDGET_NAMES.REWARDS_FREE_PRODUCT_SLIDER_WIDGET;

        this.config.mutationObserverInjector
            .register({
                targetSelector: this.config.placeholderSelector,
            })
            .subscribe((placeholder) => {
                this.config.logger?.debug(
                    "FreeProductSliderWidgetInjector found placeholder",
                    {
                        placeholder,
                    }
                );

                void (async () => {
                    const FreeProductSliderWidget =
                        await this.config.dynamicImportManager.importDefault(
                            FreeProductSliderWidgetDefinition,
                            true
                        );

                    const widget = new FreeProductSliderWidget(
                        {
                            target: placeholder,
                            isWidgetShadowRootEnabled:
                                parseOptionalBooleanDataAttr(
                                    placeholder,
                                    WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR
                                ),
                        },
                        this.config.logger
                    );

                    await widget.init();

                    this.config.eventsCollector.pushEvent(
                        this.config.eventsFactory.createWidgetInjected(
                            widgetName
                        )
                    );

                    dispatchSdkEvent(new WidgetInjectedSdkEvent(widgetName));
                })();
            });
    }
}

export default FreeProductSliderWidgetInjector;
